import { ChangeDetectorRef, Component, ElementRef, Inject, Input, OnInit, ViewChild } from '@angular/core';
import {  NgForm } from '@angular/forms';
import { MatSnackBar, MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { SharedService } from '../../../sharedServices/shared.service';
import { CommonHelper } from '../../../../utilities/common.helper';
import { HEC_CONSTANTS } from '../../../../utilities/constants';
import { decrypt } from '../../../../utilities/utilityFunctions';
import { HecResponse } from '../../../shared-interfaces/hecResponse';
import { environment } from '../../../../../environments/environment';
import { IrsipService } from '../../../../views/pages/irsip/services/irsip.service';

@Component({
	selector: 'upload-documents-modal',
	templateUrl: './upload-documents-modal.component.html',
	styleUrls: ['./upload-documents-modal.component.scss']
})
export class UploadDocumentsModalComponent implements OnInit {

	@Input('applicationId') applicationId: number;
	@ViewChild('fileDropRef', { static: false }) fileDropRef: ElementRef;
	@ViewChild('ngUploadDocumentForm', { static: false }) ngUploadDocumentForm: NgForm;
	files: any[] = [];
	private attachmentBase64: string;
	public isImageAlert: boolean = false;
	private fileExt: string = 'pdf';
	private maxSize: number = 15360;
	public loader: boolean = false;
	public fileUploader: boolean = false;
	public fileName: string = ''
	selectedDocument: any;
	isDocumentSelected: boolean;
	private loggedUser: any = null;
	public documentList = [];
	uploadedDocumentList: any = [];
	isLoading: boolean = false;
	constructor(private cdr: ChangeDetectorRef,
		public _snackBar: MatSnackBar,
		private sharedService: SharedService,
		private matDialog: MatDialog,
		public dialogRef: MatDialogRef<UploadDocumentsModalComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private irsipService: IrsipService,
	) {
		this.documentList = [
			{
				value: 0,
				hidden: false,
				mandatory: false,
				isUploaded: false,
				fileName: "DeedOfAgreement",
				label: "Deed Of Agreement",
				description: "Deed Of Agreement for undertaking a course under international support initiatives program",
			},
			{
				value: 1,
				hidden: false,
				mandatory: false,
				isUploaded: false,
				fileName: "GuaranteeToHec",
				label: "Guarantee To Hec",
				description: "Guarantee To The Higher Education Commission",
			},
			{
				value: 2,
				hidden: false,
				mandatory: true,
				isUploaded: false,
				fileName: "CertificateFinancialSoundness",
				label: "Certificate Financial Soundness",
				description: "Certification to the financial soundness of surety or guarantor by a government officer",
			},
			{
				value: 3,
				hidden: false,
				mandatory: true,
				isUploaded: false,
				fileName: "SuretyBondForTraingAbroad",
				label: "Surety Bond For Traing Abroad",
				description: "Surety Bond for undertaking studies or training abroad",
			},
		];

	}

	async ngOnInit() {
		this.loggedUser = JSON.parse(decrypt(localStorage.getItem('esp-profile-details')));
		await this.getUploadedDocuments();
	}

	onFileDropped($event) {
		this.prepareFilesList($event);
	}

	/**
	 * handle file from browsing
	 */
	fileBrowseHandler(files) {
		this.prepareFilesList(files);
	}

	/**
	 * Delete file from files list
	 * @param index (File index)
	 */
	deleteFile(index: number) {
		this.files.splice(index, 1);
	}

	/**
	 * Simulate the upload process
	 */
	uploadFilesSimulator(index: number) {
		setTimeout(() => {
			if (index === this.files.length) {
				return;
			} else {
				const progressInterval = setInterval(() => {
					if (this.files[index].progress === 100) {
						clearInterval(progressInterval);
						this.uploadFilesSimulator(index + 1);
						this.fileUploader = false;
						this.cdr.detectChanges();
					} else {
						this.files[index].progress += 5;
					}
				}, 200);
			}
		}, 1000);
	}

	/**
	 * Convert Files list to normal array list
	 * @param files (Files List)
	 */
	async prepareFilesList(e: Array<any>) {
		this.files = []
		this.attachmentBase64 = null
		if (e.length > 1) {
			return false;
		}
		let image = e[0];
		let test: File;
		let file = e[0];
		if (this.isValidFile(file)) {
			this.fileUploader = true;
			this.fileName = file.name
			this.cdr.detectChanges();
			await this.setAttachmentsPayload(file);

			for (const item of e) {
				item.progress = 0;
				this.files.push(item);
				this.cdr.detectChanges()
			}

			this.uploadFilesSimulator(0);
		}
		else {
			e = undefined
			file = undefined
			this.fileDropRef.nativeElement.value = null
		}
	}

	private isValidFile(file) {
		const extensions = (this.fileExt.split(',')).map(function (x) { return x.toLocaleLowerCase().trim(); }); // array of extensions
		const ext = file.name.toLowerCase().split('.').pop() || file.name; // file extension
		const fileSizeinKB = file.size / 1024;

		if (extensions.indexOf(ext) === -1) {
			this.isImageAlert = true;
			this._snackBar.open('Error in uploading ' + file.name + ' due to invalid file type.', '', {
				duration: 3500,
				panelClass: ['error-snackbar']
			});
			file = [];
			this.cdr.detectChanges();
			setTimeout(() => {
				this.isImageAlert = false;
				this.cdr.detectChanges();
			}, 3000);
			return false;
		} else if (file.name.match(/^[a-zA-Z-_( ')]*$/)) {
			this.isImageAlert = true;
			file = [];
			this._snackBar.open('Invalid File Name', '', {
				duration: 3500,
				panelClass: ['error-snackbar']
			});
			this.cdr.detectChanges();
			setTimeout(() => {
				this.isImageAlert = false;
				this.cdr.detectChanges();
			}, 3000);
			return false;
		}
		else if (fileSizeinKB > this.maxSize) {
			file = [];
			this.isImageAlert = true
			this._snackBar.open(file.name + ' ( ' + (fileSizeinKB / 1024).toFixed(2) + 'MB )' + ' exceeds file size limit of ' + (this.maxSize / 1024).toFixed(2) + 'MB.', '', {
				duration: 3500,
				panelClass: ['error-snackbar']
			});
			this.cdr.detectChanges();
			setTimeout(() => {
				this.isImageAlert = false;
				this.cdr.detectChanges();
			}, 3000);
			return false;
		}
		return true;
	}

	private async setAttachmentsPayload(file) {
		this.attachmentBase64 = (await this.convertFileToBase64(file)).toString();
	}


	private uploadAttachment() {
		const docList = this.documentList.filter(doc => doc.value == this.selectedDocument);
		let payload = {
			data: {
				applicationId: this.data.applicationId,
				base64: this.attachmentBase64,
				processAcronym: 'IRSIP',
				subDirectory: 'LEGALDOCUMENTS' + "//" + this.data.applicationId,
				fileName: docList[0]['fileName'] + '.pdf',
			}
		}
		this.uploadDocumentService(payload)

	}

	private async uploadDocumentService(payload) {
		this.isLoading = true;
		try {
			const res: any = await this.sharedService.irsipUploadDocument(payload).toPromise();
			this.isLoading = false;
			if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
				this.isLoading = false;
				let found = this.documentList.find(element => {
					return element.value === this.selectedDocument;
				});
				found.isUploaded = true;
				this.cdr.detectChanges();
				this.isDocumentSelected = false;
				this.selectedDocument = null;
				this.cancelUpload();
				await this.getUploadedDocuments();
				this.sharedService.showError(res.statusDescription, 'OK', 'success-snackbar');
			}
			else {
				this.isLoading = false;
				this.sharedService.showError(res.statusDescription, 'OK', 'error-snackbar');
			}
		}
		catch (error) {
			this.isLoading = false;
			if (error.status == HEC_CONSTANTS.HTTP_RESPONSE.UNAUTHORIZED) {
				this.sharedService.showError(HEC_CONSTANTS.ERROR_MESSGAES.SOMETHING_WENT_WRONG, 'OK', 'error-snackbar');
			}
		}

	}

	private convertFileToBase64(file): any {
		return new Promise((resolve, reject) => {
			CommonHelper.convertFileToBase64(file).then((result) => {
				resolve(result);
			})
				.catch(function (error) {
					resolve(null);
				})
		})
	}

	formatBytes(bytes, decimals) {
		if (bytes === 0) {
			return '0 Bytes';
		}
		const k = 1024;
		const dm = decimals <= 0 ? 0 : decimals || 2;
		const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
		const i = Math.floor(Math.log(bytes) / Math.log(k));
		return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
	}

	public uploadDocuments() {
		this.isLoading = true;
		this.uploadAttachment();
	}


	public markFormsTouched(form): void {
		CommonHelper.markFormGroupTouched(form);
	}

	public validate(f): boolean {
		if (f.status === 'VALID') {
			return true;
		}
	}

	public cancelUpload() {
		this.ngUploadDocumentForm.reset()
		this.files = []
		this.fileDropRef.nativeElement.value = null;
		this.attachmentBase64 = null;
	}

	public removeDup(array) {
		const uniqueArray = array.filter((thing, index) => {
			const _thing = JSON.stringify(thing);
			return index === array.findIndex(obj => {
				return JSON.stringify(obj) === _thing;
			});
		});
		return uniqueArray;
	}


	public ModalComponent(component, imageType, imageContent, backdropClass?, panelClass?) {
		const dialogRef = this.matDialog.open(component, {
			width: '70vw',
			height: '60vh',
			backdropClass: backdropClass,
			panelClass: panelClass,
			disableClose: true,
			autoFocus: false,
			data: { imageType: imageType, imageContent: imageContent }
		});
	}

	close(){
		this.dialogRef.close();
	}

	public downloadDocument(document) {
		this.isLoading = true;
		this.irsipService.downloadFilesLegalDocument(document,this.data.applicationId).subscribe(res=>{
			let blob = new Blob([res], {type: 'application/pdf'});
			var downloadURL = window.URL.createObjectURL(blob);
			var link = window.document.createElement('a');
			link.href = downloadURL;
			link.download = document;
			link.click();
			this.isLoading = false;
		},err=>{
			console.debug(err);
			this.isLoading = false;
		});
	}

	public async deleteDocument(fileName) {
		try {

			const payload = {
				data: {
					applicationId: this.data.applicationId,
					processAcronym: 'IRSIP',
					subDirectory: 'LEGALDOCUMENTS' + "//" + this.data.applicationId,
					fileName: fileName,
				}
			}
			this.isLoading = true;
			const res: any = await this.sharedService.irsipDeleteDocument(payload).toPromise();
			this.isLoading = false;
			if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
				this.cdr.detectChanges();
			}
			await this.getUploadedDocuments();
		}
		catch (error) {
			this.isLoading = false;
			if (error.status == HEC_CONSTANTS.HTTP_RESPONSE.UNAUTHORIZED) {
				this.sharedService.showError(HEC_CONSTANTS.ERROR_MESSGAES.SOMETHING_WENT_WRONG, 'OK', 'error-snackbar');
			}
		}

	}

	setDocumentSelectedValue(ev) {
		this.selectedDocument = ev;
	}

	public async getUploadedDocuments() {
		this.isLoading = true;
		try{
			const res: any = await this.irsipService.getFileNames(this.data.applicationId).toPromise();
			if (res.statusCode == 200) {
				this.uploadedDocumentList = res.data;
				this.uploadedDocumentList = this.uploadedDocumentList.filter(x=> x.includes('LEGALDOCUMENTS'));
				this.uploadedDocumentList = this.uploadedDocumentList.map((x: string)=>{
					 return x = x.replace(`LEGALDOCUMENTS\\${this.data.applicationId}\\`,'');
					});
				this.isLoading = false;
				if(this.uploadedDocumentList.length == this.documentList.length){
					this.updateApplicationStatusToLegalDocUploaded();
				}
			}else{
				this.isLoading = false;
			}
			for (let i = 0; i < this.uploadedDocumentList.length; i++) {
			}
		}catch(err){
			console.debug(err);
		}
	}
	async updateApplicationStatusToLegalDocUploaded(){
		this.isLoading = true;
		let payload = {
			id: this.data.applicationId
		}
		const res: any = await this.irsipService.UpdateStatusToLegalDocsUploaded(payload).toPromise();
		if (res.statusCode == 200) {
			this.sharedService.showError(res.statusDescription, 'OK', 'success-snackbar');
			this.isLoading = false;
		}else{
			this.sharedService.showError(res.statusDescription, 'OK', 'error-snackbar');
			this.isLoading = false;
		}
	}
}
